export const description = `In 1973, Larry Mawby planted his first vines. In 1976 Larry planted our Elm Valley vineyard, establishing the heart of the MAWBYness. Now with over 20 acres planted, our estate vineyard grows pinot noir, vignoles, pinot gris, regent, riesling, chardonnay and pinot meunier. To keep the MAWBYness flowing, we also purchase grapes from Leelanau County Southwest Michigan, California and Washington.`;
export const descriptionMore = `L. Mawby is fine traditional method sparkling wines, classically styled, produced entirely from grapes grown on the Leelanau Peninsula. These wines express the character of this special place, the care of the people tending the vines, and the purity of intent of those guiding the transformation of grape to sparkling wine. The poetic brother to the songs of M.Lawrence. MAWBYhome.`;

export const DATE = 'February 21st';
export const TIME = '6:30-8:30PM';
export const LOCATION_NAME = 'L. Mawby Winery';
export const SHORT_NAME = 'L. Mawby Winery';
export const ADDRESS = '4519 Elm Valley Rd';
export const CITY = 'Suttons Bay, MI';
export const LOCATION_LAT = 44.913540;
export const LOCATION_LONG = -85.653140;
export const RSVP_LINK = 'https://www.facebook.com/events/575935479547758/';
export const AGENDA_LIST = [
    {
        key: 0,
        time: '6:30pm - 7:15pm',
        detail: 'Networking + Cocktails',
    },
    {
        key: 1,
        time: '7:15pm - 7:20pm',
        detail: 'Welcoming Words',
    },
    {
        key: 2,
        time: '7:20pm - 8:00pm',
        detail: 'L. Mawby Talk on Sparkling Wine',
    },
    {
        key: 3,
        time: '8:00pm - 8:30pm',
        detail: 'Networking + Cocktails',
    }
]